export function getCountryOrRegionName(code: string): string {
  const regionNames: Record<string, string> = {
    EURO: "Europe",
    GB: "United Kingdom",
    CH: "Switzerland",
    AR: "Argentina",
    JP: "Japan",
    TR: "Turkey",
    US: "United States",
    RU: "Russia",
    BR: "Brazil",
    IN: "India",
    MX: "Mexico",
    CA: "Canada",
    AU: "Australia",
    NZ: "New Zealand",
    NO: "Norway",
    SE: "Sweden",
    DK: "Denmark",
    PL: "Poland",
    CZ: "Czechia",
    HU: "Hungary",
    RO: "Romania",
    BG: "Bulgaria",
    HR: "Croatia",
    SI: "Slovenia",
    SK: "Slovakia",
    LT: "Lithuania",
    LV: "Latvia",
    EE: "Estonia",
    FI: "Finland",
    IS: "Iceland",
    IE: "Ireland",
    PT: "Portugal",
    GR: "Greece",
    ES: "Spain",
    DE: "Germany",
    FR: "France",
    IT: "Italy",
    NL: "Netherlands",
    BE: "Belgium",
    AT: "Austria",
    LU: "Luxembourg",
    MT: "Malta",
    CY: "Cyprus",
  };

  return regionNames[code] || code;
}

export function getCountryName(code: string): string {
  const countryNames: Record<string, string> = {
    ES: "Spain",
    DE: "Germany",
    FR: "France",
    IT: "Italy",
    NL: "Netherlands",
    BE: "Belgium",
    AT: "Austria",
    PT: "Portugal",
    GR: "Greece",
    IE: "Ireland",
    FI: "Finland",
    SE: "Sweden",
    NO: "Norway",
    DK: "Denmark",
    PL: "Poland",
    CZ: "Czechia",
    HU: "Hungary",
    RO: "Romania",
    BG: "Bulgaria",
    HR: "Croatia",
    SI: "Slovenia",
    SK: "Slovakia",
    LT: "Lithuania",
    LV: "Latvia",
    EE: "Estonia",
    LU: "Luxembourg",
    MT: "Malta",
    CY: "Cyprus",
    IS: "Iceland",
    AR: "Argentina",
    JP: "Japan",
    TR: "Turkey",
    RU: "Russia",
    BR: "Brazil",
    IN: "India",
    MX: "Mexico",
    CA: "Canada",
    AU: "Australia",
    NZ: "New Zealand",
    US: "United States",
    GB: "United Kingdom",
    CH: "Switzerland",
  };

  return countryNames[code] || code;
}
